"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var ConfigSubsection_1 = tslib_1.__importDefault(require("./ConfigSubsection"));
var DropdownControl_1 = tslib_1.__importDefault(require("./DropdownControl"));
var translations_1 = require("../../utils/translations");
var dropdowns_1 = require("../../constants/dropdowns");
function getPushpinProperty(props) {
    var _a, _b, _c;
    var _d = (_c = (_b = (_a = props.properties) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.points) !== null && _c !== void 0 ? _c : {}, _e = _d.minSize, minSize = _e === void 0 ? "default" : _e, _f = _d.maxSize, maxSize = _f === void 0 ? "default" : _f;
    return {
        minSize: minSize,
        maxSize: maxSize,
    };
}
function PushpinSizeControl(props) {
    var _a = getPushpinProperty(props), minSize = _a.minSize, maxSize = _a.maxSize;
    var disabled = props.disabled, properties = props.properties, pushData = props.pushData, intl = props.intl;
    var items = translations_1.getTranslatedDropdownItems(dropdowns_1.pushpinSizeDropdownItems, intl);
    return (react_1.default.createElement(ConfigSubsection_1.default, { title: "properties.points.size.title" },
        react_1.default.createElement(DropdownControl_1.default, { value: minSize, valuePath: "points.minSize", labelText: "properties.points.size.min.title", disabled: disabled, showDisabledMessage: disabled, properties: properties, pushData: pushData, items: items }),
        react_1.default.createElement(DropdownControl_1.default, { value: maxSize, valuePath: "points.maxSize", labelText: "properties.points.size.max.title", disabled: disabled, showDisabledMessage: disabled, properties: properties, pushData: pushData, items: items })));
}
exports.default = react_intl_1.injectIntl(PushpinSizeControl);
//# sourceMappingURL=PushpinSizeControl.js.map